import { render } from "./Keywords.vue?vue&type=template&id=56dc6386&scoped=true"
import script from "./Keywords.vue?vue&type=script&lang=js"
export * from "./Keywords.vue?vue&type=script&lang=js"

import "./Keywords.vue?vue&type=style&index=0&id=56dc6386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dc6386"]])

export default __exports__